import { useNavigate } from "react-router-dom";
import Products from "@/components/laneeka/Products";

export default function ProductsPage() {
  const navigate = useNavigate();
  return (
    <main data-testid="products-page" className="pt-[108px]">
      <section className="bg-slate-950 border-b border-slate-800 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-blue-400 mb-3">Catalog</p>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-white">Products &amp; Services</h1>
        </div>
      </section>
      <Products onQuote={(name) => navigate(`/contact?product=${encodeURIComponent(name)}`)} />
    </main>
  );
}
